export var MouseButton = /*#__PURE__*/ function(MouseButton) {
    MouseButton[MouseButton["Other"] = -1] = "Other";
    MouseButton[MouseButton["Main"] = 0] = "Main";
    MouseButton[MouseButton["Auxiliary"] = 1] = "Auxiliary";
    MouseButton[MouseButton["Secondary"] = 2] = "Secondary";
    return MouseButton;
}({});
export function getClickType(event) {
    const buttonClicked = event.which - 1 || event.button;
    if (buttonClicked < 0 || buttonClicked > 2) {
        return -1;
    }
    return buttonClicked;
}

//# sourceMappingURL=helpers.js.map